// This file is auto-generated by @hey-api/openapi-ts

import { type Options, appointmentPublicConfirm, appointmentPublicCancel, appointmentIndex, appointmentCalendar, appointmentMetadata, appointmentSlots, appointmentNextAvailableDate, appointmentCreate, appointmentDestroy, appointmentShow, appointmentUpdate, appointmentCancel, appointmentReschedule, authLogin, authForgotPassword, authResetPassword, authUser, authLogOut, clientIndex, clientStore, clientDelete, clientShow, clientUpdate, coatTypeIndex, coatTypeStore, coatTypeDelete, coatTypeShow, coatTypeUpdate, contactSubmissionStore, invitationSendVerificationCode, invitationVerify, invitationShow, invitationRegister, invitationIndex, invitationStore, invitationDelete, locationIndex, locationStore, locationDelete, locationShow, locationUpdate, mediaGenerateUploadUrl, newsletterStore, petIndex, petStore, petDelete, petShow, petUpdate, scheduleShow, scheduleUpdate, serviceIndex, serviceStore, serviceDelete, serviceShow, serviceUpdate, serviceVariantIndex, serviceVariantSync, sizeCategoryIndex, sizeCategoryStore, sizeCategoryDelete, sizeCategoryShow, sizeCategoryUpdate, smsCreditsIndex, smsCreditsTransactions, smsCreditsCheckout, stripeWebhookHandle, supportTicketStore, telnyxWebhookHandle, tenantIndex, tenantShowByBookingUrl, tenantActive, tenantUpdate, tenantOnboardingRegister, tenantOnboardingUpdate, tutorialComplete, userIndex, userDelete, userShow, userUpdate } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData, type DefaultError } from '@tanstack/react-query';
import type { AppointmentPublicConfirmData, AppointmentPublicConfirmError, AppointmentPublicConfirmResponse, AppointmentPublicCancelData, AppointmentPublicCancelError, AppointmentPublicCancelResponse, AppointmentIndexData, AppointmentIndexError, AppointmentIndexResponse, AppointmentCalendarData, AppointmentMetadataData, AppointmentSlotsData, AppointmentSlotsError, AppointmentSlotsResponse, AppointmentNextAvailableDateData, AppointmentCreateData, AppointmentCreateError, AppointmentCreateResponse, AppointmentDestroyData, AppointmentDestroyError, AppointmentDestroyResponse, AppointmentShowData, AppointmentUpdateData, AppointmentUpdateError, AppointmentUpdateResponse, AppointmentCancelData, AppointmentCancelError, AppointmentCancelResponse, AppointmentRescheduleData, AppointmentRescheduleError, AppointmentRescheduleResponse, AuthLoginData, AuthLoginError, AuthLoginResponse, AuthForgotPasswordData, AuthForgotPasswordError, AuthForgotPasswordResponse, AuthResetPasswordData, AuthResetPasswordError, AuthUserData, AuthLogOutData, AuthLogOutError, AuthLogOutResponse, ClientIndexData, ClientIndexError, ClientIndexResponse, ClientStoreData, ClientStoreError, ClientStoreResponse, ClientDeleteData, ClientDeleteError, ClientDeleteResponse, ClientShowData, ClientUpdateData, ClientUpdateError, ClientUpdateResponse, CoatTypeIndexData, CoatTypeIndexError, CoatTypeIndexResponse, CoatTypeStoreData, CoatTypeStoreError, CoatTypeDeleteData, CoatTypeDeleteError, CoatTypeDeleteResponse, CoatTypeShowData, CoatTypeUpdateData, CoatTypeUpdateError, CoatTypeUpdateResponse, ContactSubmissionStoreData, ContactSubmissionStoreError, InvitationSendVerificationCodeData, InvitationSendVerificationCodeError, InvitationVerifyData, InvitationVerifyError, InvitationShowData, InvitationRegisterData, InvitationRegisterError, InvitationIndexData, InvitationIndexError, InvitationIndexResponse, InvitationStoreData, InvitationStoreError, InvitationDeleteData, InvitationDeleteError, InvitationDeleteResponse, LocationIndexData, LocationIndexError, LocationIndexResponse, LocationStoreData, LocationStoreError, LocationDeleteData, LocationDeleteError, LocationShowData, LocationUpdateData, LocationUpdateError, MediaGenerateUploadUrlData, MediaGenerateUploadUrlError, MediaGenerateUploadUrlResponse, NewsletterStoreData, NewsletterStoreError, PetIndexData, PetIndexError, PetIndexResponse, PetStoreData, PetStoreError, PetDeleteData, PetDeleteError, PetDeleteResponse, PetShowData, PetUpdateData, PetUpdateError, PetUpdateResponse, ScheduleShowData, ScheduleUpdateData, ScheduleUpdateError, ScheduleUpdateResponse, ServiceIndexData, ServiceIndexError, ServiceIndexResponse, ServiceStoreData, ServiceStoreError, ServiceDeleteData, ServiceDeleteError, ServiceDeleteResponse, ServiceShowData, ServiceUpdateData, ServiceUpdateError, ServiceUpdateResponse, ServiceVariantIndexData, ServiceVariantSyncData, ServiceVariantSyncError, SizeCategoryIndexData, SizeCategoryIndexError, SizeCategoryIndexResponse, SizeCategoryStoreData, SizeCategoryStoreError, SizeCategoryDeleteData, SizeCategoryDeleteError, SizeCategoryDeleteResponse, SizeCategoryShowData, SizeCategoryUpdateData, SizeCategoryUpdateError, SizeCategoryUpdateResponse, SmsCreditsIndexData, SmsCreditsTransactionsData, SmsCreditsTransactionsError, SmsCreditsTransactionsResponse, SmsCreditsCheckoutData, SmsCreditsCheckoutError, SmsCreditsCheckoutResponse, StripeWebhookHandleData, SupportTicketStoreData, SupportTicketStoreError, TelnyxWebhookHandleData, TelnyxWebhookHandleError, TelnyxWebhookHandleResponse, TenantIndexData, TenantShowByBookingUrlData, TenantActiveData, TenantUpdateData, TenantUpdateError, TenantUpdateResponse, TenantOnboardingRegisterData, TenantOnboardingRegisterError, TenantOnboardingUpdateData, TenantOnboardingUpdateError, TenantOnboardingUpdateResponse, TutorialCompleteData, TutorialCompleteError, TutorialCompleteResponse, UserIndexData, UserIndexError, UserIndexResponse, UserDeleteData, UserDeleteError, UserDeleteResponse, UserShowData, UserUpdateData, UserUpdateError, UserUpdateResponse } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const appointmentPublicConfirmQueryKey = (options: Options<AppointmentPublicConfirmData>) => createQueryKey('appointmentPublicConfirm', options);

export const appointmentPublicConfirmOptions = (options: Options<AppointmentPublicConfirmData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentPublicConfirm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentPublicConfirmQueryKey(options)
    });
};

export const appointmentPublicConfirmMutation = (options?: Partial<Options<AppointmentPublicConfirmData>>): UseMutationOptions<AppointmentPublicConfirmResponse, AppointmentPublicConfirmError, Options<AppointmentPublicConfirmData>> => {
    const mutationOptions: UseMutationOptions<AppointmentPublicConfirmResponse, AppointmentPublicConfirmError, Options<AppointmentPublicConfirmData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentPublicConfirm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentPublicCancelQueryKey = (options: Options<AppointmentPublicCancelData>) => createQueryKey('appointmentPublicCancel', options);

export const appointmentPublicCancelOptions = (options: Options<AppointmentPublicCancelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentPublicCancel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentPublicCancelQueryKey(options)
    });
};

export const appointmentPublicCancelMutation = (options?: Partial<Options<AppointmentPublicCancelData>>): UseMutationOptions<AppointmentPublicCancelResponse, AppointmentPublicCancelError, Options<AppointmentPublicCancelData>> => {
    const mutationOptions: UseMutationOptions<AppointmentPublicCancelResponse, AppointmentPublicCancelError, Options<AppointmentPublicCancelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentPublicCancel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentIndexQueryKey = (options?: Options<AppointmentIndexData>) => createQueryKey('appointmentIndex', options);

export const appointmentIndexOptions = (options?: Options<AppointmentIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentIndexQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const appointmentIndexInfiniteQueryKey = (options?: Options<AppointmentIndexData>): QueryKey<Options<AppointmentIndexData>> => createQueryKey('appointmentIndex', options, true);

export const appointmentIndexInfiniteOptions = (options?: Options<AppointmentIndexData>) => {
    return infiniteQueryOptions<AppointmentIndexResponse, AppointmentIndexError, InfiniteData<AppointmentIndexResponse>, QueryKey<Options<AppointmentIndexData>>, number | Pick<QueryKey<Options<AppointmentIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AppointmentIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await appointmentIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentIndexInfiniteQueryKey(options)
    });
};

export const appointmentCalendarQueryKey = (options?: Options<AppointmentCalendarData>) => createQueryKey('appointmentCalendar', options);

export const appointmentCalendarOptions = (options?: Options<AppointmentCalendarData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentCalendar({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentCalendarQueryKey(options)
    });
};

export const appointmentMetadataQueryKey = (options: Options<AppointmentMetadataData>) => createQueryKey('appointmentMetadata', options);

export const appointmentMetadataOptions = (options: Options<AppointmentMetadataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentMetadataQueryKey(options)
    });
};

export const appointmentSlotsQueryKey = (options: Options<AppointmentSlotsData>) => createQueryKey('appointmentSlots', options);

export const appointmentSlotsOptions = (options: Options<AppointmentSlotsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentSlots({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentSlotsQueryKey(options)
    });
};

export const appointmentSlotsInfiniteQueryKey = (options: Options<AppointmentSlotsData>): QueryKey<Options<AppointmentSlotsData>> => createQueryKey('appointmentSlots', options, true);

export const appointmentSlotsInfiniteOptions = (options: Options<AppointmentSlotsData>) => {
    return infiniteQueryOptions<AppointmentSlotsResponse, AppointmentSlotsError, InfiniteData<AppointmentSlotsResponse>, QueryKey<Options<AppointmentSlotsData>>, number | Pick<QueryKey<Options<AppointmentSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AppointmentSlotsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await appointmentSlots({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentSlotsInfiniteQueryKey(options)
    });
};

export const appointmentNextAvailableDateQueryKey = (options: Options<AppointmentNextAvailableDateData>) => createQueryKey('appointmentNextAvailableDate', options);

export const appointmentNextAvailableDateOptions = (options: Options<AppointmentNextAvailableDateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentNextAvailableDate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentNextAvailableDateQueryKey(options)
    });
};

export const appointmentCreateQueryKey = (options: Options<AppointmentCreateData>) => createQueryKey('appointmentCreate', options);

export const appointmentCreateOptions = (options: Options<AppointmentCreateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentCreate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentCreateQueryKey(options)
    });
};

export const appointmentCreateMutation = (options?: Partial<Options<AppointmentCreateData>>): UseMutationOptions<AppointmentCreateResponse, AppointmentCreateError, Options<AppointmentCreateData>> => {
    const mutationOptions: UseMutationOptions<AppointmentCreateResponse, AppointmentCreateError, Options<AppointmentCreateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentCreate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentDestroyMutation = (options?: Partial<Options<AppointmentDestroyData>>): UseMutationOptions<AppointmentDestroyResponse, AppointmentDestroyError, Options<AppointmentDestroyData>> => {
    const mutationOptions: UseMutationOptions<AppointmentDestroyResponse, AppointmentDestroyError, Options<AppointmentDestroyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentDestroy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentShowQueryKey = (options: Options<AppointmentShowData>) => createQueryKey('appointmentShow', options);

export const appointmentShowOptions = (options: Options<AppointmentShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentShowQueryKey(options)
    });
};

export const appointmentUpdateMutation = (options?: Partial<Options<AppointmentUpdateData>>): UseMutationOptions<AppointmentUpdateResponse, AppointmentUpdateError, Options<AppointmentUpdateData>> => {
    const mutationOptions: UseMutationOptions<AppointmentUpdateResponse, AppointmentUpdateError, Options<AppointmentUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentCancelQueryKey = (options: Options<AppointmentCancelData>) => createQueryKey('appointmentCancel', options);

export const appointmentCancelOptions = (options: Options<AppointmentCancelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appointmentCancel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentCancelQueryKey(options)
    });
};

export const appointmentCancelMutation = (options?: Partial<Options<AppointmentCancelData>>): UseMutationOptions<AppointmentCancelResponse, AppointmentCancelError, Options<AppointmentCancelData>> => {
    const mutationOptions: UseMutationOptions<AppointmentCancelResponse, AppointmentCancelError, Options<AppointmentCancelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentCancel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appointmentRescheduleMutation = (options?: Partial<Options<AppointmentRescheduleData>>): UseMutationOptions<AppointmentRescheduleResponse, AppointmentRescheduleError, Options<AppointmentRescheduleData>> => {
    const mutationOptions: UseMutationOptions<AppointmentRescheduleResponse, AppointmentRescheduleError, Options<AppointmentRescheduleData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await appointmentReschedule({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authLoginQueryKey = (options: Options<AuthLoginData>) => createQueryKey('authLogin', options);

export const authLoginOptions = (options: Options<AuthLoginData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authLoginQueryKey(options)
    });
};

export const authLoginMutation = (options?: Partial<Options<AuthLoginData>>): UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await authLogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authForgotPasswordQueryKey = (options: Options<AuthForgotPasswordData>) => createQueryKey('authForgotPassword', options);

export const authForgotPasswordOptions = (options: Options<AuthForgotPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authForgotPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authForgotPasswordQueryKey(options)
    });
};

export const authForgotPasswordMutation = (options?: Partial<Options<AuthForgotPasswordData>>): UseMutationOptions<AuthForgotPasswordResponse, AuthForgotPasswordError, Options<AuthForgotPasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthForgotPasswordResponse, AuthForgotPasswordError, Options<AuthForgotPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await authForgotPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authResetPasswordQueryKey = (options: Options<AuthResetPasswordData>) => createQueryKey('authResetPassword', options);

export const authResetPasswordOptions = (options: Options<AuthResetPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authResetPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authResetPasswordQueryKey(options)
    });
};

export const authResetPasswordMutation = (options?: Partial<Options<AuthResetPasswordData>>): UseMutationOptions<unknown, AuthResetPasswordError, Options<AuthResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<unknown, AuthResetPasswordError, Options<AuthResetPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await authResetPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authUserQueryKey = (options?: Options<AuthUserData>) => createQueryKey('authUser', options);

export const authUserOptions = (options?: Options<AuthUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authUserQueryKey(options)
    });
};

export const authLogOutQueryKey = (options?: Options<AuthLogOutData>) => createQueryKey('authLogOut', options);

export const authLogOutOptions = (options?: Options<AuthLogOutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authLogOut({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: authLogOutQueryKey(options)
    });
};

export const authLogOutMutation = (options?: Partial<Options<AuthLogOutData>>): UseMutationOptions<AuthLogOutResponse, AuthLogOutError, Options<AuthLogOutData>> => {
    const mutationOptions: UseMutationOptions<AuthLogOutResponse, AuthLogOutError, Options<AuthLogOutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await authLogOut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientIndexQueryKey = (options?: Options<ClientIndexData>) => createQueryKey('clientIndex', options);

export const clientIndexOptions = (options?: Options<ClientIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await clientIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIndexQueryKey(options)
    });
};

export const clientIndexInfiniteQueryKey = (options?: Options<ClientIndexData>): QueryKey<Options<ClientIndexData>> => createQueryKey('clientIndex', options, true);

export const clientIndexInfiniteOptions = (options?: Options<ClientIndexData>) => {
    return infiniteQueryOptions<ClientIndexResponse, ClientIndexError, InfiniteData<ClientIndexResponse>, QueryKey<Options<ClientIndexData>>, number | Pick<QueryKey<Options<ClientIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ClientIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await clientIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientIndexInfiniteQueryKey(options)
    });
};

export const clientStoreQueryKey = (options: Options<ClientStoreData>) => createQueryKey('clientStore', options);

export const clientStoreOptions = (options: Options<ClientStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await clientStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientStoreQueryKey(options)
    });
};

export const clientStoreMutation = (options?: Partial<Options<ClientStoreData>>): UseMutationOptions<ClientStoreResponse, ClientStoreError, Options<ClientStoreData>> => {
    const mutationOptions: UseMutationOptions<ClientStoreResponse, ClientStoreError, Options<ClientStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clientStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientDeleteMutation = (options?: Partial<Options<ClientDeleteData>>): UseMutationOptions<ClientDeleteResponse, ClientDeleteError, Options<ClientDeleteData>> => {
    const mutationOptions: UseMutationOptions<ClientDeleteResponse, ClientDeleteError, Options<ClientDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clientDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const clientShowQueryKey = (options: Options<ClientShowData>) => createQueryKey('clientShow', options);

export const clientShowOptions = (options: Options<ClientShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await clientShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clientShowQueryKey(options)
    });
};

/**
 * ⚠️Cannot generate request documentation: Call to a member function unique() on null
 */
export const clientUpdateMutation = (options?: Partial<Options<ClientUpdateData>>): UseMutationOptions<ClientUpdateResponse, ClientUpdateError, Options<ClientUpdateData>> => {
    const mutationOptions: UseMutationOptions<ClientUpdateResponse, ClientUpdateError, Options<ClientUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clientUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const coatTypeIndexQueryKey = (options?: Options<CoatTypeIndexData>) => createQueryKey('coatTypeIndex', options);

export const coatTypeIndexOptions = (options?: Options<CoatTypeIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await coatTypeIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: coatTypeIndexQueryKey(options)
    });
};

export const coatTypeIndexInfiniteQueryKey = (options?: Options<CoatTypeIndexData>): QueryKey<Options<CoatTypeIndexData>> => createQueryKey('coatTypeIndex', options, true);

export const coatTypeIndexInfiniteOptions = (options?: Options<CoatTypeIndexData>) => {
    return infiniteQueryOptions<CoatTypeIndexResponse, CoatTypeIndexError, InfiniteData<CoatTypeIndexResponse>, QueryKey<Options<CoatTypeIndexData>>, number | Pick<QueryKey<Options<CoatTypeIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CoatTypeIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await coatTypeIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: coatTypeIndexInfiniteQueryKey(options)
    });
};

export const coatTypeStoreQueryKey = (options: Options<CoatTypeStoreData>) => createQueryKey('coatTypeStore', options);

export const coatTypeStoreOptions = (options: Options<CoatTypeStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await coatTypeStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: coatTypeStoreQueryKey(options)
    });
};

export const coatTypeStoreMutation = (options?: Partial<Options<CoatTypeStoreData>>): UseMutationOptions<unknown, CoatTypeStoreError, Options<CoatTypeStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, CoatTypeStoreError, Options<CoatTypeStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await coatTypeStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const coatTypeDeleteMutation = (options?: Partial<Options<CoatTypeDeleteData>>): UseMutationOptions<CoatTypeDeleteResponse, CoatTypeDeleteError, Options<CoatTypeDeleteData>> => {
    const mutationOptions: UseMutationOptions<CoatTypeDeleteResponse, CoatTypeDeleteError, Options<CoatTypeDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await coatTypeDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const coatTypeShowQueryKey = (options: Options<CoatTypeShowData>) => createQueryKey('coatTypeShow', options);

export const coatTypeShowOptions = (options: Options<CoatTypeShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await coatTypeShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: coatTypeShowQueryKey(options)
    });
};

export const coatTypeUpdateMutation = (options?: Partial<Options<CoatTypeUpdateData>>): UseMutationOptions<CoatTypeUpdateResponse, CoatTypeUpdateError, Options<CoatTypeUpdateData>> => {
    const mutationOptions: UseMutationOptions<CoatTypeUpdateResponse, CoatTypeUpdateError, Options<CoatTypeUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await coatTypeUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contactSubmissionStoreQueryKey = (options: Options<ContactSubmissionStoreData>) => createQueryKey('contactSubmissionStore', options);

export const contactSubmissionStoreOptions = (options: Options<ContactSubmissionStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await contactSubmissionStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: contactSubmissionStoreQueryKey(options)
    });
};

export const contactSubmissionStoreMutation = (options?: Partial<Options<ContactSubmissionStoreData>>): UseMutationOptions<unknown, ContactSubmissionStoreError, Options<ContactSubmissionStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, ContactSubmissionStoreError, Options<ContactSubmissionStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await contactSubmissionStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationSendVerificationCodeQueryKey = (options: Options<InvitationSendVerificationCodeData>) => createQueryKey('invitationSendVerificationCode', options);

export const invitationSendVerificationCodeOptions = (options: Options<InvitationSendVerificationCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationSendVerificationCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationSendVerificationCodeQueryKey(options)
    });
};

export const invitationSendVerificationCodeMutation = (options?: Partial<Options<InvitationSendVerificationCodeData>>): UseMutationOptions<unknown, InvitationSendVerificationCodeError, Options<InvitationSendVerificationCodeData>> => {
    const mutationOptions: UseMutationOptions<unknown, InvitationSendVerificationCodeError, Options<InvitationSendVerificationCodeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await invitationSendVerificationCode({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationVerifyQueryKey = (options: Options<InvitationVerifyData>) => createQueryKey('invitationVerify', options);

export const invitationVerifyOptions = (options: Options<InvitationVerifyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationVerify({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationVerifyQueryKey(options)
    });
};

export const invitationVerifyMutation = (options?: Partial<Options<InvitationVerifyData>>): UseMutationOptions<unknown, InvitationVerifyError, Options<InvitationVerifyData>> => {
    const mutationOptions: UseMutationOptions<unknown, InvitationVerifyError, Options<InvitationVerifyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await invitationVerify({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationShowQueryKey = (options: Options<InvitationShowData>) => createQueryKey('invitationShow', options);

export const invitationShowOptions = (options: Options<InvitationShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationShowQueryKey(options)
    });
};

export const invitationRegisterQueryKey = (options: Options<InvitationRegisterData>) => createQueryKey('invitationRegister', options);

export const invitationRegisterOptions = (options: Options<InvitationRegisterData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationRegister({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationRegisterQueryKey(options)
    });
};

export const invitationRegisterMutation = (options?: Partial<Options<InvitationRegisterData>>): UseMutationOptions<unknown, InvitationRegisterError, Options<InvitationRegisterData>> => {
    const mutationOptions: UseMutationOptions<unknown, InvitationRegisterError, Options<InvitationRegisterData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await invitationRegister({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationIndexQueryKey = (options?: Options<InvitationIndexData>) => createQueryKey('invitationIndex', options);

export const invitationIndexOptions = (options?: Options<InvitationIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationIndexQueryKey(options)
    });
};

export const invitationIndexInfiniteQueryKey = (options?: Options<InvitationIndexData>): QueryKey<Options<InvitationIndexData>> => createQueryKey('invitationIndex', options, true);

export const invitationIndexInfiniteOptions = (options?: Options<InvitationIndexData>) => {
    return infiniteQueryOptions<InvitationIndexResponse, InvitationIndexError, InfiniteData<InvitationIndexResponse>, QueryKey<Options<InvitationIndexData>>, number | Pick<QueryKey<Options<InvitationIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<InvitationIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await invitationIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationIndexInfiniteQueryKey(options)
    });
};

export const invitationStoreQueryKey = (options: Options<InvitationStoreData>) => createQueryKey('invitationStore', options);

export const invitationStoreOptions = (options: Options<InvitationStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await invitationStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: invitationStoreQueryKey(options)
    });
};

export const invitationStoreMutation = (options?: Partial<Options<InvitationStoreData>>): UseMutationOptions<unknown, InvitationStoreError, Options<InvitationStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, InvitationStoreError, Options<InvitationStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await invitationStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationDeleteMutation = (options?: Partial<Options<InvitationDeleteData>>): UseMutationOptions<InvitationDeleteResponse, InvitationDeleteError, Options<InvitationDeleteData>> => {
    const mutationOptions: UseMutationOptions<InvitationDeleteResponse, InvitationDeleteError, Options<InvitationDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await invitationDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationIndexQueryKey = (options?: Options<LocationIndexData>) => createQueryKey('locationIndex', options);

export const locationIndexOptions = (options?: Options<LocationIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await locationIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: locationIndexQueryKey(options)
    });
};

export const locationIndexInfiniteQueryKey = (options?: Options<LocationIndexData>): QueryKey<Options<LocationIndexData>> => createQueryKey('locationIndex', options, true);

export const locationIndexInfiniteOptions = (options?: Options<LocationIndexData>) => {
    return infiniteQueryOptions<LocationIndexResponse, LocationIndexError, InfiniteData<LocationIndexResponse>, QueryKey<Options<LocationIndexData>>, number | Pick<QueryKey<Options<LocationIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<LocationIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await locationIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: locationIndexInfiniteQueryKey(options)
    });
};

export const locationStoreQueryKey = (options: Options<LocationStoreData>) => createQueryKey('locationStore', options);

export const locationStoreOptions = (options: Options<LocationStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await locationStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: locationStoreQueryKey(options)
    });
};

export const locationStoreMutation = (options?: Partial<Options<LocationStoreData>>): UseMutationOptions<unknown, LocationStoreError, Options<LocationStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, LocationStoreError, Options<LocationStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await locationStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationDeleteMutation = (options?: Partial<Options<LocationDeleteData>>): UseMutationOptions<unknown, LocationDeleteError, Options<LocationDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, LocationDeleteError, Options<LocationDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await locationDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationShowQueryKey = (options: Options<LocationShowData>) => createQueryKey('locationShow', options);

export const locationShowOptions = (options: Options<LocationShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await locationShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: locationShowQueryKey(options)
    });
};

export const locationUpdateMutation = (options?: Partial<Options<LocationUpdateData>>): UseMutationOptions<unknown, LocationUpdateError, Options<LocationUpdateData>> => {
    const mutationOptions: UseMutationOptions<unknown, LocationUpdateError, Options<LocationUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await locationUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mediaGenerateUploadUrlQueryKey = (options: Options<MediaGenerateUploadUrlData>) => createQueryKey('mediaGenerateUploadUrl', options);

export const mediaGenerateUploadUrlOptions = (options: Options<MediaGenerateUploadUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mediaGenerateUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mediaGenerateUploadUrlQueryKey(options)
    });
};

export const mediaGenerateUploadUrlMutation = (options?: Partial<Options<MediaGenerateUploadUrlData>>): UseMutationOptions<MediaGenerateUploadUrlResponse, MediaGenerateUploadUrlError, Options<MediaGenerateUploadUrlData>> => {
    const mutationOptions: UseMutationOptions<MediaGenerateUploadUrlResponse, MediaGenerateUploadUrlError, Options<MediaGenerateUploadUrlData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mediaGenerateUploadUrl({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const newsletterStoreQueryKey = (options: Options<NewsletterStoreData>) => createQueryKey('newsletterStore', options);

export const newsletterStoreOptions = (options: Options<NewsletterStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await newsletterStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: newsletterStoreQueryKey(options)
    });
};

export const newsletterStoreMutation = (options?: Partial<Options<NewsletterStoreData>>): UseMutationOptions<unknown, NewsletterStoreError, Options<NewsletterStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, NewsletterStoreError, Options<NewsletterStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await newsletterStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const petIndexQueryKey = (options?: Options<PetIndexData>) => createQueryKey('petIndex', options);

export const petIndexOptions = (options?: Options<PetIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await petIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: petIndexQueryKey(options)
    });
};

export const petIndexInfiniteQueryKey = (options?: Options<PetIndexData>): QueryKey<Options<PetIndexData>> => createQueryKey('petIndex', options, true);

export const petIndexInfiniteOptions = (options?: Options<PetIndexData>) => {
    return infiniteQueryOptions<PetIndexResponse, PetIndexError, InfiniteData<PetIndexResponse>, QueryKey<Options<PetIndexData>>, number | Pick<QueryKey<Options<PetIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PetIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await petIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: petIndexInfiniteQueryKey(options)
    });
};

export const petStoreQueryKey = (options: Options<PetStoreData>) => createQueryKey('petStore', options);

export const petStoreOptions = (options: Options<PetStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await petStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: petStoreQueryKey(options)
    });
};

export const petStoreMutation = (options?: Partial<Options<PetStoreData>>): UseMutationOptions<unknown, PetStoreError, Options<PetStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, PetStoreError, Options<PetStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await petStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const petDeleteMutation = (options?: Partial<Options<PetDeleteData>>): UseMutationOptions<PetDeleteResponse, PetDeleteError, Options<PetDeleteData>> => {
    const mutationOptions: UseMutationOptions<PetDeleteResponse, PetDeleteError, Options<PetDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await petDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const petShowQueryKey = (options: Options<PetShowData>) => createQueryKey('petShow', options);

export const petShowOptions = (options: Options<PetShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await petShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: petShowQueryKey(options)
    });
};

export const petUpdateMutation = (options?: Partial<Options<PetUpdateData>>): UseMutationOptions<PetUpdateResponse, PetUpdateError, Options<PetUpdateData>> => {
    const mutationOptions: UseMutationOptions<PetUpdateResponse, PetUpdateError, Options<PetUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await petUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const scheduleShowQueryKey = (options: Options<ScheduleShowData>) => createQueryKey('scheduleShow', options);

export const scheduleShowOptions = (options: Options<ScheduleShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await scheduleShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: scheduleShowQueryKey(options)
    });
};

export const scheduleUpdateMutation = (options?: Partial<Options<ScheduleUpdateData>>): UseMutationOptions<ScheduleUpdateResponse, ScheduleUpdateError, Options<ScheduleUpdateData>> => {
    const mutationOptions: UseMutationOptions<ScheduleUpdateResponse, ScheduleUpdateError, Options<ScheduleUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await scheduleUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceIndexQueryKey = (options?: Options<ServiceIndexData>) => createQueryKey('serviceIndex', options);

export const serviceIndexOptions = (options?: Options<ServiceIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceIndexQueryKey(options)
    });
};

export const serviceIndexInfiniteQueryKey = (options?: Options<ServiceIndexData>): QueryKey<Options<ServiceIndexData>> => createQueryKey('serviceIndex', options, true);

export const serviceIndexInfiniteOptions = (options?: Options<ServiceIndexData>) => {
    return infiniteQueryOptions<ServiceIndexResponse, ServiceIndexError, InfiniteData<ServiceIndexResponse>, QueryKey<Options<ServiceIndexData>>, number | Pick<QueryKey<Options<ServiceIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ServiceIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await serviceIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceIndexInfiniteQueryKey(options)
    });
};

export const serviceStoreQueryKey = (options: Options<ServiceStoreData>) => createQueryKey('serviceStore', options);

export const serviceStoreOptions = (options: Options<ServiceStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceStoreQueryKey(options)
    });
};

export const serviceStoreMutation = (options?: Partial<Options<ServiceStoreData>>): UseMutationOptions<unknown, ServiceStoreError, Options<ServiceStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, ServiceStoreError, Options<ServiceStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceDeleteMutation = (options?: Partial<Options<ServiceDeleteData>>): UseMutationOptions<ServiceDeleteResponse, ServiceDeleteError, Options<ServiceDeleteData>> => {
    const mutationOptions: UseMutationOptions<ServiceDeleteResponse, ServiceDeleteError, Options<ServiceDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceShowQueryKey = (options: Options<ServiceShowData>) => createQueryKey('serviceShow', options);

export const serviceShowOptions = (options: Options<ServiceShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceShowQueryKey(options)
    });
};

export const serviceUpdateMutation = (options?: Partial<Options<ServiceUpdateData>>): UseMutationOptions<ServiceUpdateResponse, ServiceUpdateError, Options<ServiceUpdateData>> => {
    const mutationOptions: UseMutationOptions<ServiceUpdateResponse, ServiceUpdateError, Options<ServiceUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const serviceVariantIndexQueryKey = (options: Options<ServiceVariantIndexData>) => createQueryKey('serviceVariantIndex', options);

export const serviceVariantIndexOptions = (options: Options<ServiceVariantIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await serviceVariantIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: serviceVariantIndexQueryKey(options)
    });
};

export const serviceVariantSyncMutation = (options?: Partial<Options<ServiceVariantSyncData>>): UseMutationOptions<unknown, ServiceVariantSyncError, Options<ServiceVariantSyncData>> => {
    const mutationOptions: UseMutationOptions<unknown, ServiceVariantSyncError, Options<ServiceVariantSyncData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await serviceVariantSync({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sizeCategoryIndexQueryKey = (options?: Options<SizeCategoryIndexData>) => createQueryKey('sizeCategoryIndex', options);

export const sizeCategoryIndexOptions = (options?: Options<SizeCategoryIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sizeCategoryIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sizeCategoryIndexQueryKey(options)
    });
};

export const sizeCategoryIndexInfiniteQueryKey = (options?: Options<SizeCategoryIndexData>): QueryKey<Options<SizeCategoryIndexData>> => createQueryKey('sizeCategoryIndex', options, true);

export const sizeCategoryIndexInfiniteOptions = (options?: Options<SizeCategoryIndexData>) => {
    return infiniteQueryOptions<SizeCategoryIndexResponse, SizeCategoryIndexError, InfiniteData<SizeCategoryIndexResponse>, QueryKey<Options<SizeCategoryIndexData>>, number | Pick<QueryKey<Options<SizeCategoryIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SizeCategoryIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await sizeCategoryIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sizeCategoryIndexInfiniteQueryKey(options)
    });
};

export const sizeCategoryStoreQueryKey = (options: Options<SizeCategoryStoreData>) => createQueryKey('sizeCategoryStore', options);

export const sizeCategoryStoreOptions = (options: Options<SizeCategoryStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sizeCategoryStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sizeCategoryStoreQueryKey(options)
    });
};

export const sizeCategoryStoreMutation = (options?: Partial<Options<SizeCategoryStoreData>>): UseMutationOptions<unknown, SizeCategoryStoreError, Options<SizeCategoryStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, SizeCategoryStoreError, Options<SizeCategoryStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sizeCategoryStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sizeCategoryDeleteMutation = (options?: Partial<Options<SizeCategoryDeleteData>>): UseMutationOptions<SizeCategoryDeleteResponse, SizeCategoryDeleteError, Options<SizeCategoryDeleteData>> => {
    const mutationOptions: UseMutationOptions<SizeCategoryDeleteResponse, SizeCategoryDeleteError, Options<SizeCategoryDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sizeCategoryDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sizeCategoryShowQueryKey = (options: Options<SizeCategoryShowData>) => createQueryKey('sizeCategoryShow', options);

export const sizeCategoryShowOptions = (options: Options<SizeCategoryShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sizeCategoryShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sizeCategoryShowQueryKey(options)
    });
};

export const sizeCategoryUpdateMutation = (options?: Partial<Options<SizeCategoryUpdateData>>): UseMutationOptions<SizeCategoryUpdateResponse, SizeCategoryUpdateError, Options<SizeCategoryUpdateData>> => {
    const mutationOptions: UseMutationOptions<SizeCategoryUpdateResponse, SizeCategoryUpdateError, Options<SizeCategoryUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sizeCategoryUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const smsCreditsIndexQueryKey = (options?: Options<SmsCreditsIndexData>) => createQueryKey('smsCreditsIndex', options);

export const smsCreditsIndexOptions = (options?: Options<SmsCreditsIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await smsCreditsIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: smsCreditsIndexQueryKey(options)
    });
};

export const smsCreditsTransactionsQueryKey = (options?: Options<SmsCreditsTransactionsData>) => createQueryKey('smsCreditsTransactions', options);

export const smsCreditsTransactionsOptions = (options?: Options<SmsCreditsTransactionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await smsCreditsTransactions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: smsCreditsTransactionsQueryKey(options)
    });
};

export const smsCreditsTransactionsInfiniteQueryKey = (options?: Options<SmsCreditsTransactionsData>): QueryKey<Options<SmsCreditsTransactionsData>> => createQueryKey('smsCreditsTransactions', options, true);

export const smsCreditsTransactionsInfiniteOptions = (options?: Options<SmsCreditsTransactionsData>) => {
    return infiniteQueryOptions<SmsCreditsTransactionsResponse, SmsCreditsTransactionsError, InfiniteData<SmsCreditsTransactionsResponse>, QueryKey<Options<SmsCreditsTransactionsData>>, number | Pick<QueryKey<Options<SmsCreditsTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SmsCreditsTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await smsCreditsTransactions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: smsCreditsTransactionsInfiniteQueryKey(options)
    });
};

export const smsCreditsCheckoutQueryKey = (options: Options<SmsCreditsCheckoutData>) => createQueryKey('smsCreditsCheckout', options);

export const smsCreditsCheckoutOptions = (options: Options<SmsCreditsCheckoutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await smsCreditsCheckout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: smsCreditsCheckoutQueryKey(options)
    });
};

export const smsCreditsCheckoutMutation = (options?: Partial<Options<SmsCreditsCheckoutData>>): UseMutationOptions<SmsCreditsCheckoutResponse, SmsCreditsCheckoutError, Options<SmsCreditsCheckoutData>> => {
    const mutationOptions: UseMutationOptions<SmsCreditsCheckoutResponse, SmsCreditsCheckoutError, Options<SmsCreditsCheckoutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await smsCreditsCheckout({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stripeWebhookHandleQueryKey = (options?: Options<StripeWebhookHandleData>) => createQueryKey('stripeWebhookHandle', options);

/**
 * Handle Stripe webhooks
 */
export const stripeWebhookHandleOptions = (options?: Options<StripeWebhookHandleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await stripeWebhookHandle({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: stripeWebhookHandleQueryKey(options)
    });
};

/**
 * Handle Stripe webhooks
 */
export const stripeWebhookHandleMutation = (options?: Partial<Options<StripeWebhookHandleData>>): UseMutationOptions<unknown, DefaultError, Options<StripeWebhookHandleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StripeWebhookHandleData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await stripeWebhookHandle({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const supportTicketStoreQueryKey = (options: Options<SupportTicketStoreData>) => createQueryKey('supportTicketStore', options);

export const supportTicketStoreOptions = (options: Options<SupportTicketStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await supportTicketStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: supportTicketStoreQueryKey(options)
    });
};

export const supportTicketStoreMutation = (options?: Partial<Options<SupportTicketStoreData>>): UseMutationOptions<unknown, SupportTicketStoreError, Options<SupportTicketStoreData>> => {
    const mutationOptions: UseMutationOptions<unknown, SupportTicketStoreError, Options<SupportTicketStoreData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await supportTicketStore({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const telnyxWebhookHandleQueryKey = (options?: Options<TelnyxWebhookHandleData>) => createQueryKey('telnyxWebhookHandle', options);

export const telnyxWebhookHandleOptions = (options?: Options<TelnyxWebhookHandleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await telnyxWebhookHandle({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: telnyxWebhookHandleQueryKey(options)
    });
};

export const telnyxWebhookHandleMutation = (options?: Partial<Options<TelnyxWebhookHandleData>>): UseMutationOptions<TelnyxWebhookHandleResponse, TelnyxWebhookHandleError, Options<TelnyxWebhookHandleData>> => {
    const mutationOptions: UseMutationOptions<TelnyxWebhookHandleResponse, TelnyxWebhookHandleError, Options<TelnyxWebhookHandleData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await telnyxWebhookHandle({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantIndexQueryKey = (options?: Options<TenantIndexData>) => createQueryKey('tenantIndex', options);

export const tenantIndexOptions = (options?: Options<TenantIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tenantIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantIndexQueryKey(options)
    });
};

export const tenantShowByBookingUrlQueryKey = (options: Options<TenantShowByBookingUrlData>) => createQueryKey('tenantShowByBookingUrl', options);

export const tenantShowByBookingUrlOptions = (options: Options<TenantShowByBookingUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tenantShowByBookingUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantShowByBookingUrlQueryKey(options)
    });
};

export const tenantActiveQueryKey = (options?: Options<TenantActiveData>) => createQueryKey('tenantActive', options);

export const tenantActiveOptions = (options?: Options<TenantActiveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tenantActive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantActiveQueryKey(options)
    });
};

export const tenantUpdateMutation = (options?: Partial<Options<TenantUpdateData>>): UseMutationOptions<TenantUpdateResponse, TenantUpdateError, Options<TenantUpdateData>> => {
    const mutationOptions: UseMutationOptions<TenantUpdateResponse, TenantUpdateError, Options<TenantUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await tenantUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantOnboardingRegisterQueryKey = (options: Options<TenantOnboardingRegisterData>) => createQueryKey('tenantOnboardingRegister', options);

export const tenantOnboardingRegisterOptions = (options: Options<TenantOnboardingRegisterData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tenantOnboardingRegister({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantOnboardingRegisterQueryKey(options)
    });
};

export const tenantOnboardingRegisterMutation = (options?: Partial<Options<TenantOnboardingRegisterData>>): UseMutationOptions<unknown, TenantOnboardingRegisterError, Options<TenantOnboardingRegisterData>> => {
    const mutationOptions: UseMutationOptions<unknown, TenantOnboardingRegisterError, Options<TenantOnboardingRegisterData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await tenantOnboardingRegister({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantOnboardingUpdateQueryKey = (options: Options<TenantOnboardingUpdateData>) => createQueryKey('tenantOnboardingUpdate', options);

export const tenantOnboardingUpdateOptions = (options: Options<TenantOnboardingUpdateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tenantOnboardingUpdate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantOnboardingUpdateQueryKey(options)
    });
};

export const tenantOnboardingUpdateMutation = (options?: Partial<Options<TenantOnboardingUpdateData>>): UseMutationOptions<TenantOnboardingUpdateResponse, TenantOnboardingUpdateError, Options<TenantOnboardingUpdateData>> => {
    const mutationOptions: UseMutationOptions<TenantOnboardingUpdateResponse, TenantOnboardingUpdateError, Options<TenantOnboardingUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await tenantOnboardingUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tutorialCompleteQueryKey = (options?: Options<TutorialCompleteData>) => createQueryKey('tutorialComplete', options);

/**
 * Mark the tutorial as completed for the authenticated user
 */
export const tutorialCompleteOptions = (options?: Options<TutorialCompleteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tutorialComplete({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tutorialCompleteQueryKey(options)
    });
};

/**
 * Mark the tutorial as completed for the authenticated user
 */
export const tutorialCompleteMutation = (options?: Partial<Options<TutorialCompleteData>>): UseMutationOptions<TutorialCompleteResponse, TutorialCompleteError, Options<TutorialCompleteData>> => {
    const mutationOptions: UseMutationOptions<TutorialCompleteResponse, TutorialCompleteError, Options<TutorialCompleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await tutorialComplete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userIndexQueryKey = (options?: Options<UserIndexData>) => createQueryKey('userIndex', options);

export const userIndexOptions = (options?: Options<UserIndexData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await userIndex({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userIndexQueryKey(options)
    });
};

export const userIndexInfiniteQueryKey = (options?: Options<UserIndexData>): QueryKey<Options<UserIndexData>> => createQueryKey('userIndex', options, true);

export const userIndexInfiniteOptions = (options?: Options<UserIndexData>) => {
    return infiniteQueryOptions<UserIndexResponse, UserIndexError, InfiniteData<UserIndexResponse>, QueryKey<Options<UserIndexData>>, number | Pick<QueryKey<Options<UserIndexData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UserIndexData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await userIndex({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userIndexInfiniteQueryKey(options)
    });
};

export const userDeleteMutation = (options?: Partial<Options<UserDeleteData>>): UseMutationOptions<UserDeleteResponse, UserDeleteError, Options<UserDeleteData>> => {
    const mutationOptions: UseMutationOptions<UserDeleteResponse, UserDeleteError, Options<UserDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await userDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userShowQueryKey = (options: Options<UserShowData>) => createQueryKey('userShow', options);

export const userShowOptions = (options: Options<UserShowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await userShow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userShowQueryKey(options)
    });
};

export const userUpdateMutation = (options?: Partial<Options<UserUpdateData>>): UseMutationOptions<UserUpdateResponse, UserUpdateError, Options<UserUpdateData>> => {
    const mutationOptions: UseMutationOptions<UserUpdateResponse, UserUpdateError, Options<UserUpdateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await userUpdate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};